import * as PIXI from "pixi.js-legacy";
import { injectable, inject } from "inversify";
import { EASE, getTween, getTweenAsync } from "../../framework/src/modules/Tween";
import SERVICE_IDENTIFIER from "../../framework/src/constants/identifiers";
import IApp from "../../framework/src/engine/IApp";
import { pixiSetTimeoutAsync } from "../../framework/src/engine/pixi/pixiTimeout";
import { getRandomBoolean, getRandomInt } from "../../framework/src/helpers";
import { getSprite } from "../../framework/src/modules/Sprite";
import { Frames } from "../Code/Frames";
import SystemConfig, { CONFIG_PARAMS } from "../../framework/src/system/SystemConfig";
import PixiAudio from "../../framework/src/engine/pixi/PixiAudio";


@injectable()
export default class BigWin {

    bigWinFactors: {
        "bigWin": number,
        "megaWin": number;
        "superMegaWin": number;
    };

    bwCont: PIXI.Container;
    bwFire: PIXI.AnimatedSprite;
    bwFireScale: { x: number, y: number } = { x: 1, y: 1 };

    bwTable: PIXI.Sprite;
    bwTextImg: PIXI.Sprite;
    fsTextImg: PIXI.Sprite;
    bwTextImgScale: number = 1.5;//3;
    textImgCont: PIXI.Container;

    bwScore: PIXI.Container;
    bwStyle: PIXI.IBitmapTextStyle = {
        fontName: "font_win-export",
        fontSize: 80,
        align: "right",
        tint: 0xFFFFFF,
        letterSpacing: 0,
        maxWidth: 1280
    };

    shakeTimer: number;
    shakeOffset: number;

    shakeTimerDefault: number;
    shakeOffsetDefault: number;
    shakeMinOffsetDefault: number;

    shakeLimit: number;
    shakeLimitDefault: number;
    shakePath: { x: number, y: number };

    containerToShake: PIXI.Container;

    audio: PixiAudio;

    constructor(
        @inject(SERVICE_IDENTIFIER.EngineApp) app: IApp,
        @inject(SERVICE_IDENTIFIER.SystemConfig) sysConfig: SystemConfig,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: PixiAudio,
    ) {

        this.bigWinFactors = {
            "bigWin": sysConfig.get(CONFIG_PARAMS.BIG_WIN_FACTOR),
            "megaWin": sysConfig.get(CONFIG_PARAMS.MEGA_WIN_FACTOR),
            "superMegaWin": sysConfig.get(CONFIG_PARAMS.SUPER_WIN_FACTOR),
        }

        this.containerToShake = app["_app"]["stage"];
        this.audio = audio;
    }

    init() {

        this.bwCont = new PIXI.Container();
        this.bwCont.name = 'BigWin Continer';
        this.bwCont.position.set(647, 330); //645, 300);
        this.bwCont.visible = false;
        this.bwCont.alpha = 0;

        this.bwFire = new PIXI.AnimatedSprite(Frames["bigWinFire"]);
        this.bwFire.name = "BigWin TableFire"
        this.bwFire.scale.x = this.bwFireScale.x;
        this.bwFire.scale.y = this.bwFireScale.y;
        this.bwFire.anchor.set(0.5, 0.5);
        this.bwFire.loop = true;
        this.bwFire.alpha = 1;
        this.bwFire.visible = false;
        this.bwFire.animationSpeed = 0.40;
        this.bwFire.stop();

        this.bwTable = getSprite("bw_table.png", 0, 0);
        this.bwTable.name = "BigWin Table";
        this.bwTable.pivot.set(6, 5); // not centered ? need pivot to be moved instead of position 
        this.bwTable.alpha = 0;
        this.bwTable.visible = false;

        // this.bwFire.addChild(this.bwTable);

        this.bwTextImg = this.setTextImgSprite("bigwin.png");
        this.bwTextImg.name = "BigWin Text Img";
        this.fsTextImg = this.setTextImgSprite("winText.png");
        this.fsTextImg.name = "FreeSpin Text Img";

        this.textImgCont = new PIXI.Container();
        this.textImgCont.name = "BigWin Text Img Cont";
        this.textImgCont.addChild(this.bwTextImg, this.fsTextImg);
        this.textImgCont.pivot.set(this.textImgCont.width / 2, this.textImgCont.height / 2);
        this.textImgCont.alpha = 0;
        this.textImgCont.visible = false;

        this.bwScore = new PIXI.Container();
        this.bwScore.name = "BigWin Score Text Cont";
        this.bwScore.position.set(0, 80); //100); // 110); //130);
        this.bwScore.alpha = 0;
        this.bwScore.visible = false;

        this.bwCont.addChild(this.bwFire, this.bwTable, this.textImgCont, this.bwScore);

        this.shakeTimerDefault = 1300;// 2000;
        this.shakeOffsetDefault = 2;
        this.shakeMinOffsetDefault = 1;
        this.shakeLimitDefault = 5;

        this.setShakeScreen();
    }

    setTextImgSprite(textImgName: string) {
        let tempTextImg = getSprite(textImgName, -10, -70);//-65);
        tempTextImg.scale.set(3, 3);//2, 2);
        tempTextImg.alpha = 0;
        tempTextImg.visible = false;
        return tempTextImg
    }

    setBWScoreText(scoreText: string) {

        if (this.bwScore.visible) {
            this.turnOff(this.bwScore);
        }

        this.bwScore.removeChildren();
        let letterOffset = this.bwStyle.fontSize / 8;
        let tempLetterXcenter = 0;

        for (let l = scoreText.length - 1; l > -1; l--) {
            let thousendOffset = 0;
            if (scoreText.length > 3 && l > scoreText.length - 4) {
                thousendOffset = this.bwStyle.fontSize / 2; // -- inserting half of style font with as offset space
            }
            if (scoreText.length > 6 && l > scoreText.length - 7) {
                thousendOffset += this.bwStyle.fontSize / 2;   // -- inserting another half if the string length have more then one thousend space
            }

            let tempLetter = new PIXI.BitmapText(scoreText[l], this.bwStyle);
            tempLetter.name = "scoreDigit_" + scoreText[l];
            tempLetterXcenter = tempLetter.width / 2;
            let tempXpos = (l * (this.bwStyle.fontSize + letterOffset) + thousendOffset);

            tempLetter.pivot.set(tempLetterXcenter, 0);
            tempLetter.position.set(tempXpos, 0);
            tempLetter.alpha = 0;

            this.bwScore.addChild(tempLetter);
        }

        this.bwScore.pivot.set((this.bwScore.width / 2 - this.bwStyle.fontSize / 2), 0);
    }

    /**
     * @name setShakeScreen - setting up values for the shake animation, 
     *                 if given empty values the defaults are read from the constructor (see constructor for "default" variables) 
     * @param {number} timeToShake - how long should the shake last in milliseconds ( converted to seconds )
     * @param {number} shakeOffset - how fare the shake should go each "move"
     * @param {number} shakeLimit - limit of the shake (offset), preventing traveling out of view
     */
    setShakeScreen(
        timeToShake: number = this.shakeTimerDefault,
        shakeOffset: number = this.shakeOffsetDefault,
        shakeLimit: number = this.shakeLimitDefault,
    ) {
        this.shakeTimer = timeToShake * 0.001; // convert miliseconds to seconds
        this.shakeOffset = shakeOffset; // how much the random path of shaking can be
        this.shakeLimit = shakeLimit; // is the bound limit how fare the shake can move with the offset
    }

    getRandomPath(stage: PIXI.Container) {

        let randomX = getRandomInt(this.shakeMinOffsetDefault, this.shakeOffset);
        let randomY = getRandomInt(this.shakeMinOffsetDefault, this.shakeOffset);

        /*
         * random direction modification 
         */
        if (getRandomBoolean()) {
            randomX *= -1;
        }
        if (getRandomBoolean()) {
            randomX *= -1;
        }

        if (Math.abs(randomX + stage.x) > this.shakeLimit) {
            randomX *= -1;
        }

        if (Math.abs(randomY + stage.y) > this.shakeLimit) {
            randomY *= -1;
        }

        this.shakePath = { x: randomX, y: randomY };
    }

    // checking if the new shake position is out of bounds, so the shaked obj doesn't "shake off" the screen/canvas
    outOfShakeBounds(cont: PIXI.Container) {

        if (Math.abs(cont.x) > this.shakeLimit) {
            cont.x = 0;
        }

        if (cont.y < 0 || Math.abs(cont.y) > this.shakeLimit) {
            cont.y = 0;
        }
    }

    async shakeScreenAsync() {

        // return new Promise<void>((resolve) => {

            PIXI.Ticker.shared.add(this.startShake, this);

            pixiSetTimeoutAsync(this.shakeTimer).then(() => {

                this.containerToShake.x = 0;
                this.containerToShake.y = 0;

                PIXI.Ticker.shared.remove(this.startShake, this);

                // resolve();
            });
        // });
    }

    async startShake(delta: number) {

        this.getRandomPath(this.containerToShake);
        this.outOfShakeBounds(this.containerToShake);

        this.containerToShake.x += this.shakePath.x * delta;
        this.containerToShake.y += this.shakePath.y * delta;
    }

    /*
     * BIG WIN ANIMATION - animation of the container that contains the fire , table , text image and container with numbers (score /win)
     */
    async bigWinAnimation(freeSpinEnd: boolean = false) {

        this.turnOn(this.bwTable, 0, 0);
        this.turnOn(this.bwFire, 0, 0);
        this.bwFire.play();

        if (freeSpinEnd) {
            this.audio.playTrack("bwin_FreeSpins");
            this.turnOff(this.bwTextImg, 1);
            this.turnOn(this.fsTextImg, 1, 1);
        } else {
            this.audio.playTrack("bwin_BigWin");
            this.turnOff(this.fsTextImg, 1);
            this.turnOn(this.bwTextImg, 1, 1);
        }

        // await
        this.turnOn(this.textImgCont, this.bwTextImgScale, 0);
        // await
        this.turnOn(this.bwScore);
        // await 
        this.turnOn(this.bwCont);

        this.objectFallInAnim(this.bwFire);
        this.objectFallInAnim(this.bwTable);

        pixiSetTimeoutAsync(0.5).then(() => {
            getTween(this.textImgCont, { alpha: 1 }, 400, EASE.LINEAR);
        })

        await pixiSetTimeoutAsync(0.4);
        getTweenAsync(this.textImgCont.scale, { x: 1.4, y: 1.4 }, 100, EASE.QUAR_I);

        await getTweenAsync(this.textImgCont.scale, { x: 1, y: 1 }, 450, EASE.CUBI_I); //SINE_O

        this.setShakeScreen(200);//150);//400);//300); //200 - default for shaking of table and numbers

        await this.shakeScreenAsync();
        pixiSetTimeoutAsync(2).then(() => {
            this.audio.playTrack("bwin_Money");
        });

        await this.scoreTextAnimation(freeSpinEnd);

        this.setShakeScreen();//400);//300); //200        
    }

    async objectFallInAnim(pixiObj: PIXI.Container) {
        getTweenAsync(pixiObj, { alpha: 1 }, 200, EASE.LINEAR);
        await getTweenAsync(pixiObj.scale, { x: 1, y: 1 }, 600, /*EASE.BOUN_O*/ EASE.QUAR_I).then(async () => {
            await getTweenAsync(pixiObj.scale, { x: 0.95, y: 0.95 }, 250, EASE.BACK_O);
            await getTweenAsync(pixiObj.scale, { x: 1, y: 1 }, 150, EASE.LINEAR);
        })
    }

    async bigWinFadeOut() {
        let promiseList = [];
        promiseList.push(pixiSetTimeoutAsync(0.2).then(async () => {
            getTweenAsync(this.textImgCont, { alpha: 0 }, 300, EASE.LINEAR);
            getTweenAsync(this.bwFire, { alpha: 0 }, 300, EASE.LINEAR);
            await getTweenAsync(this.bwTable, { alpha: 0 }, 300, EASE.LINEAR);
        })
        );

        for (let i = this.bwScore.children.length - 1; i > -1; i--) {
            promiseList.push(this.scoreTextEndAnimation(i));
        }

        await Promise.all(promiseList);
        promiseList.length = 0;
        this.cleanUpBigWin();
    }

    /*
     * at the end of big win clean up the text and hide/reset (see turnOff and turnOn methods)
     * (.visible = false, .alpha = 0, .scale = 1)
     * other sprites and animatedSprites for big win animation
     * (table fire, table , big win text texture and big win score text)
     */
    cleanUpBigWin() {

        for (let i = this.bwScore.children.length - 1; i >= 0; i--) {
            //console.log("i in bigwin", i, " > ", this.bwScore.children[i]);
            let child = this.bwScore.children[i];
            if (child instanceof PIXI.BitmapText) {
                (child.children[0] as PIXI.Mesh).texture.destroy();
                child.destroy({ children: true, texture:true , baseTexture: true });                
                // child.removeChildren();
            }
        }
        this.bwScore.removeChildren();

        this.turnOff(this.bwCont);
        this.bwFire.stop();
        this.turnOff(this.bwFire);
        this.turnOff(this.bwTable);

        this.turnOff(this.bwTextImg);
        this.turnOff(this.fsTextImg);
        this.turnOff(this.textImgCont);

        this.turnOff(this.bwScore);
    }

    /**
     * just small help functions to turn OFF visiblity and alpha of specific PIXI.Object
     * and reset scale after animations / tweens
     * @param {PIXI.Container} pixiCont - pixi object that have ancestor in PIXI.Container
     * @param {number} scale    -   number to scale the specified container to, mostly to reset from previous tweens ,
     *                              default is 1
     */
    turnOff(pixiCont: PIXI.Container, scale: number = 1) {
        pixiCont.alpha = 0;
        pixiCont.scale.set(scale, scale);
        pixiCont.visible = false;
    }

    /**
     * just small help functions to turn ON visiblity and alpha and scale of specific PIXI.Object,
     * before animation 
     * @param {PIXI.Container} pixiCont - pixi object that have ancestor in PIXI.Container
     * @param {number} scale    -   number to scale the specified container to, mostly to reset from previous tweens ,  
     *                              default is 1
     * @param {number} alpha    -   the alpha to modify before it will be visible, some will need to have it 0 for the tween animations
     *                              default is 1
     */
    turnOn(pixiCont: PIXI.Container, scale: number = 1, alpha: number = 1) {
        pixiCont.scale.set(scale, scale);
        pixiCont.alpha = alpha;
        pixiCont.visible = true;
    }

    /**
     *  ANIMATION FOR EACH NUMBER IN THE WIN SCORE
     * @param {boolean} freespinEnd
     */
    async scoreTextAnimation(freespinEnd: boolean) {
        let promiseList = [];

        if (freespinEnd) {
            promiseList.push(
                pixiSetTimeoutAsync(2.6).then(async () => {
                    this.audio.playTrack("bonus_Lock_Fire");                    
                })
            );
        } else {
            promiseList.push( pixiSetTimeoutAsync(2.6 + 0.7)//.then(async () => { })
            );
        }

        for (let i = 0; i < this.bwScore.children.length; i++) {
            this.turnOn(this.bwScore.children[i] as PIXI.Container, 3, 0);
            promiseList.push(
                pixiSetTimeoutAsync(i * 0.35).then(async () => {

                    getTweenAsync(this.bwScore.children[i], { alpha: 1 }, 350, EASE.LINEAR); //QUIN_I) );                    
                    await getTweenAsync(this.bwScore.children[i].scale, { x: 0.84, y: 0.84 }, 350, EASE.SINE_I);//QUIN_I));                    
                    this.audio.playTrack("bwin_BigWin_Counter");
                    this.shakeScreenAsync();
                })
            );
        }
        await Promise.all(promiseList);
        promiseList.length = 0;
    }

    async scoreTextEndAnimation(i) {
        getTweenAsync(this.bwScore.children[i], { alpha: 0 }, 500, EASE.LINEAR);//QUIN_I);
        await getTweenAsync(this.bwScore.children[i].scale, { x: 2, y: 2 }, 500, EASE.LINEAR);//QUIN_I);
        await this.turnOff(this.bwScore.children[i] as PIXI.Container);
    }

    destroy() {
        this.bwFire.stop();
        this.destroyElement(this.bwFire);
        this.bwFire = undefined;

        this.destroyElement(this.bwTable);
        this.bwTable = undefined;

        this.destroyElement(this.bwTextImg);
        this.bwTextImg = undefined;

        this.destroyElement(this.fsTextImg);
        this.fsTextImg = undefined;

        this.destroyElement(this.textImgCont);
        this.textImgCont = undefined;

        this.destroyElement(this.bwScore);
        this.bwScore = undefined;

        this.destroyElement(this.bwCont);
        this.bwCont = undefined;
    }

    destroyElement(el: PIXI.Container|PIXI.Sprite): void {
        el.visible = false;
        el.alpha = 0;
        el.destroy({ children: true, baseTexture: true });
    }
}